import PropTypes from "prop-types";

const OTPTitle = ({ title, content }) => {
  return (
    <div>
      <h3 className="text-center w-100">{title}</h3>
      <p className="text-center w-100 mb-4 mt-2" style={{ fontSize: "15px" }}>
        {content}
      </p>
    </div>
  );
};

OTPTitle.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
};

OTPTitle.defaultProps = {};

export default OTPTitle;
